import { Student } from '../types/student';

export const exportToCSV = (students: Student[]) => {
  if (students.length === 0) return;
  
  // Definir campos específicos para exportação
  const fields = [
    'nome_completo',
    'email',
    'cpf',
    'rg',
    'orgao_expedidor',
    'data_de_nascimento',
    'endereco',
    'numero_da_residencia',
    'complemento',
    'cep',
    'cidade',
    'estado',
    'bairro',
    'cod_curso',
    'cod_curso_2',
    'metodo_de_pagamento',
    'parcelas',
    'celular',
    'data',
    'status',
    'motivo_do_erro'
  ];

  const headers = fields.join(',');
  const data = students.map(student => 
    fields.map(field => student[field as keyof Student] || '').join(',')
  ).join('\n');
  
  const csv = `${headers}\n${data}`;
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `matriculas_${students[0].status === 'success' ? 'concluidas' : 'erros'}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};